export default "__VITE_ASSET__CGN$Udir__"